// ===== Labels for 3-4 player online rooms (names, teams, scores) =====
// Pure helpers over the server view; 2-player rooms never use them.

export const isMulti = (view) => !!view && view.numPlayers > 2;

export const seatNumber = (seat) => 'ABCD'.indexOf(seat) + 1;

// "a Luca" / "ad Anna"
export const toName = (name) => `${/^[aA]/.test(name) ? 'ad' : 'a'} ${name}`;

// "Luca", "Luca e Sara", "Luca, Sara e Dario"
export const joinNames = (names) =>
  names.length < 2 ? names.join('') : `${names.slice(0, -1).join(', ')} e ${names[names.length - 1]}`;

export function playerName(view, seat) {
  const p = (view.players || []).find((x) => x.seat === seat);
  return (p && p.nickname) || `Giocatore ${seatNumber(seat)}`;
}

// Who is speaking/acting, from the local player's point of view.
export function actorName(view, seat) {
  return seat === view.you ? 'Tu' : playerName(view, seat);
}

export function teamMembers(view, side) {
  return (view.players || []).filter((p) => p.side === side).map((p) => p.seat);
}

export function isPartner(view, seat) {
  return view.numPlayers === 4 && seat !== view.you && teamMembers(view, view.yourSide).includes(seat);
}

// Short side label: "Tu", "Luca" (3 players) or "La tua squadra" / "Squadra avversaria" (4).
export function sideLabel(view, side) {
  if (view.numPlayers === 4) return side === view.yourSide ? 'La tua squadra' : 'Squadra avversaria';
  return side === view.you ? 'Tu' : playerName(view, side);
}

// "tu e Giulia" / "Luca e Sara"
export function teamNames(view, side) {
  return teamMembers(view, side)
    .map((s) => (s === view.you ? 'tu' : playerName(view, s)))
    .join(' e ');
}

// Sides ordered with the local player's side first.
export function orderedSides(view) {
  const sides = Object.keys(view.sideScores || {});
  const mine = view.yourSide;
  return [mine, ...sides.filter((s) => s !== mine)];
}

// "tu 5, Luca 3, Sara 2" or "la tua squadra 6, squadra avversaria 4"
export function scoreSummary(view, scores = view.sideScores) {
  return orderedSides(view)
    .map((s) => `${sideLabel(view, s).replace(/^La /, 'la ').replace(/^Squadra/, 'squadra').replace(/^Tu$/, 'tu')} ${scores[s]}`)
    .join(', ');
}
